// src/Services/fetchDetalleEmpleado.js
import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

/**
 * @param {string|number} numeroEmpleado - Número de empleado a consultar (PK)
 * @param {string} token - Token JWT del usuario logueado
 */
export const fetchDetalleEmpleado = async (numeroEmpleado, token) => {
  const method = "GET";
  const headers = { Authorization: `Bearer ${token}` };
  const url = `${USERS.detalleEmpleado}/${encodeURIComponent(numeroEmpleado)}`;

  const response = await ApiRequestInterceptor(url, method, undefined, headers);

  if (response.code === 200 && response.data.usuario) {
    return response.data.usuario;
  } else {
    throw new Error(response?.data?.error || "Error desconocido");
  }
};

